export default "__VITE_ASSET__fim3SQq8__"